var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgilysysBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1146.7 406.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #0299d6;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #7fbc42;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #231f20;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M548.4,353.9h-61.2v-216.8h67.1c42,0,70.3,21.2,70.3,52.7s-18.6,42.6-44.6,51.1c31.9,5.9,52.4,23.8,52.4,52.4s-33.5,60.5-84,60.5ZM543.5,230.5c29.6,0,52.1-14.3,52.1-37.4s-18.2-32.5-43.9-32.5h-35.8v70h27.7ZM546.4,253.9h-30.6v76.5h34.5c32.6,0,53.4-13,53.4-38.1s-26.4-38.4-57.3-38.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M730.4,357.1c-48.2,0-75.8-37.4-75.8-81.4s27.7-81.4,75.8-81.4,75.8,37.4,75.8,81.4-27.7,81.4-75.8,81.4ZM730.4,217.2c-31.2,0-46.5,26-46.5,58.6s15.3,58.6,46.5,58.6,46.5-26,46.5-58.6-15.3-58.6-46.5-58.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M904.8,357.1c-48.2,0-75.8-37.4-75.8-81.4s27.7-81.4,75.8-81.4,75.8,37.4,75.8,81.4-27.7,81.4-75.8,81.4ZM904.8,217.2c-31.2,0-46.5,26-46.5,58.6s15.3,58.6,46.5,58.6,46.5-26,46.5-58.6-15.3-58.6-46.5-58.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1003.4,353.9V124.1h29.3v147.5l62.5-73.9h33.9l-66.1,76.8,71.6,79.4h-35.5l-66.4-77.5v77.5h-29.3Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.7,178.1c46.4,0,84.1-37.6,84.1-84.1S424.2,10,377.7,10s-84.1,37.6-84.1,84.1,37.6,84.1,84.1,84.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.9,123c10.5,13.7,16.3,32.4,16.3,55.7v118h-35.9v-24.5c-11.4,14.3-35.9,28.6-65.3,28.6s-55.9-21.2-55.9-54.3,27.4-53.9,69.8-56.7c17.6-1.2,34.7-1.6,50.6-1.6v-8.6c0-33.1-13.5-53.1-45.7-53.1s-36.3,5.3-51.8,13.9l-8.6-26.9c20.4-12.2,41.6-16.7,66.9-16.7s12.7.6,18.5,1.8c-17.9-7.2-37.4-11.2-57.9-11.2-85.4,0-154.7,69.3-154.7,154.7s69.3,154.7,154.7,154.7,154.7-69.3,154.7-154.7-21.7-90.5-55.7-118.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.6,246.4c0,18.4,11.4,27.3,31,27.3s40.4-10.6,53.9-25.3v-36.3c-16.3.8-30.2,2-44.1,3.7-22.9,2.4-40.8,9.4-40.8,30.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgilysysBook);
export default __webpack_public_path__ + "static/media/AgilysysBook.854cdd26b1653919f31590297475c61f.svg";
export { ForwardRef as ReactComponent };